export default __webpack_public_path__ + "static/triangle_b.345f1879491080fba66280afd73f6579.png";